import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cookie-consent"
//
// Manages the two-tier cookie consent banner for analytics tracking.
// Communicates with the analytics controller via Stimulus outlets.
//
// Consent levels stored in cookie:
//   "all"            — analytics + session replay
//   "analytics_only" — analytics only
//   "rejected"       — nothing
export default class extends Controller {
  static outlets = ["analytics"]
  static targets = ["preferences", "analyticsToggle", "replayToggle"]
  static values = { consent: String }

  connect() {
    this.consentValue = this.#readCookie()
  }

  acceptAll() {
    this.#applyConsent("all")
  }

  reject() {
    this.#applyConsent("rejected")
  }

  manage() {
    this.preferencesTarget.classList.toggle("hidden")
  }

  save() {
    const analyticsEnabled = this.analyticsToggleTarget.checked
    const replayEnabled = this.replayToggleTarget.checked

    if (!analyticsEnabled) {
      this.#applyConsent("rejected")
    } else if (replayEnabled) {
      this.#applyConsent("all")
    } else {
      this.#applyConsent("analytics_only")
    }
  }

  consentValueChanged() {
    if (this.consentValue) {
      this.element.remove()
    }
  }

  // Private

  #applyConsent(value) {
    this.#setCookie(value)
    this.#notifyAnalytics(value)
    this.consentValue = value
  }

  #notifyAnalytics(value) {
    if (!this.hasAnalyticsOutlet) return

    if (value === "all") {
      this.analyticsOutlet.grantFullConsent()
    } else if (value === "analytics_only") {
      this.analyticsOutlet.grantConsent()
    } else {
      this.analyticsOutlet.revokeConsent()
    }
  }

  #setCookie(value) {
    const maxAge = 365 * 24 * 60 * 60 // 1 year
    document.cookie = `wellio_analytics_consent=${value}; path=/; max-age=${maxAge}; SameSite=Lax`
  }

  #readCookie() {
    const match = document.cookie.match(/wellio_analytics_consent=(\w+)/)
    return match ? match[1] : ""
  }
}
